import React, { useContext } from 'react';
import PropTypes from 'prop-types';
// components
import ModuleQuestion from './../../components/ModuleQuestion/ModuleQuestion';
import { QuestionContext, ModuleContext, CommonContext } from './../../contexts/constant/ActionTypes';

const ModuleQuestionPage = ({ history, match }) => {
    const questionContext = useContext(QuestionContext);
    const moduleContext = useContext(ModuleContext);
    const commonContext = useContext(CommonContext);

    return (
        <ModuleQuestion
            history={history}
            match={match}
            questionContext={questionContext}
            moduleContext={moduleContext}
            commonContext={commonContext}
        />
    );
}

ModuleQuestionPage.propTypes = {
    history: PropTypes.instanceOf(Object),
    match: PropTypes.instanceOf(Object)
};

ModuleQuestionPage.defaultProps = {
    history: {},
    match: {}
};

export default ModuleQuestionPage;



// WEBPACK FOOTER //
// ./containers/ModuleQuestionPage/ModuleQuestionPage.js